import type { ReactNode } from "react";
import { Navigate } from "react-router";

import { useGrants } from "../lib/session";
import { effectiveRole, type Grants } from "../lib/scopes";

interface Props {
  require: (g: Grants) => boolean;
  /** Set for a route guard; omit for a section gate that renders a notice in place. */
  redirectTo?: string;
  /** Shown by the section gate — name the tier, not the scope string. */
  requires?: string;
  children: ReactNode;
}

/**
 * Hides what the caller cannot use. This is an affordance, not authorization —
 * the server enforces every one of these gates independently, and a 403 that
 * arrives anyway is rendered where it happens.
 */
export default function ScopeGate({ require, redirectTo, requires, children }: Props) {
  const grants = useGrants();
  if (require(grants)) return <>{children}</>;
  if (redirectTo) return <Navigate to={redirectTo} replace />;
  return (
    <div className="text-xs text-kw-text-faint border border-kw-border-subtle rounded p-3">
      Requires {requires ?? "a higher privilege"} — you are {effectiveRole(grants)}.
    </div>
  );
}
